import { useEffect, useState } from "react";

import {
  NovaPosLogin,
  type WebPosStaff,
} from "./NovaPosLogin";
import { NovaPosBoard } from "./NovaPosBoard";

export function NovaPosShell() {
  const [staff, setStaff] = useState<WebPosStaff | null>(null);
  const [ready, setReady] = useState(false);

  async function restoreSession() {
    try {
      const response = await fetch("/api/pos/session", {
        credentials: "include",
        cache: "no-store",
      });

      if (!response.ok) {
        setStaff(null);
        return;
      }

      const payload = (await response.json()) as {
        authenticated?: boolean;
        staff?: WebPosStaff;
      };

      if (payload.authenticated && payload.staff) {
        setStaff(payload.staff);
      } else {
        setStaff(null);
      }
    } catch {
      setStaff(null);
    } finally {
      setReady(true);
    }
  }

  useEffect(() => {
    void restoreSession();
  }, []);

  async function signOut() {
    try {
      await fetch("/api/pos/logout", {
        method: "POST",
        credentials: "include",
      });
    } finally {
      setStaff(null);
    }
  }

  if (!ready) {
    return (
      <main className="flex min-h-screen items-center justify-center bg-[#F6F1E8] text-[#193B3F]">
        <div className="text-center">
          <p className="text-xs font-extrabold uppercase tracking-[.2em] text-[#62787A]">
            Nova Res Culina
          </p>
          <p className="mt-2 font-bold">
            Restoring your station…
          </p>
        </div>
      </main>
    );
  }

  if (!staff) {
    return (
      <NovaPosLogin
        onSignedIn={(signedInStaff) => {
          setStaff(signedInStaff);
        }}
      />
    );
  }

  return (
    <main className="min-h-screen bg-[#F6F1E8] text-[#193B3F]">
      <header className="border-b border-[#D9CFBE] bg-[#FFFCF6]">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
          <div>
            <p className="text-[10px] font-extrabold uppercase tracking-[.24em] text-[#B68B18]">
              Nova Res Culina
            </p>

            <h1 className="text-xl font-bold">
              Web POS
            </h1>
          </div>

          <div className="flex items-center gap-4">
            <div className="hidden text-right sm:block">
              <p className="text-sm font-extrabold">
                {staff.displayName}
              </p>

              <p className="text-[10px] font-bold uppercase tracking-[.14em] text-[#62787A]">
                {staff.role}
              </p>
            </div>

            <button
              className="rounded-xl border border-[#D9CFBE] bg-[#F8F4EC] px-4 py-2 text-sm font-bold"
              type="button"
              onClick={() => void signOut()}
            >
              Lock station
            </button>
          </div>
        </div>
      </header>

      <div className="mx-auto max-w-7xl px-6 py-8">
        <NovaPosBoard />
      </div>
    </main>
  );
}
